import React from "react";

import EcoIcon from "../../../components/eco-icon/EcoIcon";
import type { QuizReviewQuestion } from "../quizApi";
import "./Quiz.css";

/**
 * Gabarito de uma tentativa: a opção marcada contra a correta, pergunta a
 * pergunta. Usado no resultado do supervisor e no "Ver respostas" do staff.
 */
const QuizReview: React.FC<{ questions: QuizReviewQuestion[] }> = ({ questions }) => (
  <ol className="quizReview">
    {questions.map((q) => (
      <li key={q.id} className={`quizReview__item${q.isCorrect ? " is-right" : q.isCorrect === false ? " is-wrong" : ""}`}>
        <div className="quizReview__head">
          <span className="quizReview__prompt">
            {q.order}. {q.prompt}
          </span>
          {q.isCorrect === null ? null : (
            <span className={`quizReview__badge${q.isCorrect ? " is-right" : " is-wrong"}`}>
              <EcoIcon name={q.isCorrect ? "check" : "x"} size={14} />
              {q.isCorrect ? "Acertou" : "Errou"}
            </span>
          )}
        </div>
        <ul className="quizReview__options">
          {q.options.map((o) => {
            const chosen = q.selectedOptionIds.includes(o.id);
            return (
              <li
                key={o.id}
                className={`quizReview__option${o.isCorrect ? " is-correct" : ""}${chosen && !o.isCorrect ? " is-chosenWrong" : ""}`}
              >
                <span>{o.label}</span>
                <span className="quizReview__tags">
                  {chosen ? <span className="quizReview__tag">marcada</span> : null}
                  {o.isCorrect ? <span className="quizReview__tag quizReview__tag--ok">correta</span> : null}
                </span>
              </li>
            );
          })}
        </ul>
        {q.explanation ? <p className="quizReview__explanation">{q.explanation}</p> : null}
      </li>
    ))}
  </ol>
);

export default QuizReview;
